import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import CurrentLanguage from '@/components/mixins/CurrentLanguage';
import axios from 'axios';
import i18n from './i18n'
import AuthService from '@/interfaces/authentication'
import moment from 'moment';

const getBaseUrl = () => {
    const chunks = window.location.href.split('/print');
    return chunks[0] + '/print/';
}
const baseUrl = getBaseUrl();
Vue.prototype.authVaccinations = new AuthService(baseUrl + 'jouw-vaccinaties-redirect');
Vue.prototype.authNegativeTests = new AuthService(baseUrl + 'jouw-testresultaat-redirect');
Vue.prototype.authRecovery = new AuthService(baseUrl + 'recovery-redirect');

require('moment/locale/es');

// Choose Locale
moment.locale('en');

const axiosConfig = {
    baseURL: ''
};
Vue.prototype.$axios = axios.create(axiosConfig)

Vue.mixin(CurrentLanguage);
const requestOptions = {
    method: 'GET'
};

Vue.config.productionTip = false
fetch(process.env.BASE_URL + 'config.json', requestOptions)
    .then((response) => response.json())
    .then((config) => {
        Vue.prototype.$config = config
        new Vue({
            router,
            store,
            i18n,
            render: h => h(App)
        }).$mount('#app')
    })
